export default __webpack_public_path__ + "static/media/WarningCircle.35ddb9fe.svg";